import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Image, { StaticImageData } from 'next/image'
import {
  ExploreRoot,
  RecipesContainer,
  RecipesWrapper,
  WfrWrapper,
  TitleWrapper,
  RecipeBadge,
  BorderWrapper,
} from './Explore.styles'
import wfr from '../../../../../../public/assets/recipes/categories/individual/explore-icon.webp'
import chickenIcon from '../../../../../../public/assets/recipes/categories/individual/chicken-icon.webp'
import cowIcon from '../../../../../../public/assets/recipes/categories/individual/cow-icon.webp'
import deerIcon from '../../../../../../public/assets/recipes/categories/individual/deer-icon.webp'
import turkeyIcon from '../../../../../../public/assets/recipes/categories/individual/turkey-icon.webp'
import duckIcon from '../../../../../../public/assets/recipes/categories/individual/duck-icon.webp'
import lambIcon from '../../../../../../public/assets/recipes/categories/individual/lamb-icon.webp'
import { SectionTitle } from '../styles'
import { RecipePill } from '../../../components/SixRecipes/SixRecipes'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { BorderWave } from 'components/BorderWave'
import { Proteins } from 'models/Pet'

type RecipeItem = {
  name: Proteins
  badge: StaticImageData
  label: string
  icon: 'chicken' | 'deer' | 'cow' | 'lamb' | 'turkey' | 'duck'
  link: string
}

export const Explore = ({ hide }: { hide: Proteins }) => {
  const { t } = useTranslation()

  const RecipeList: RecipeItem[] = [
    {
      name: Proteins.CHICKEN,
      badge: chickenIcon,
      label: t('recipes:overview.six-recipes.recipe-1'),
      icon: 'chicken',
      link: '/recipes/chicken'
    },
    {
      name: Proteins.BEEF,
      badge: cowIcon,
      label: t('recipes:overview.six-recipes.recipe-2'),
      icon: 'cow',
      link: '/recipes/beef'
    },
    {
      name: Proteins.LAMB,
      badge: lambIcon,
      label: t('recipes:overview.six-recipes.recipe-3'),
      icon: 'lamb',
      link: '/recipes/lamb'
    },
    {
      name: Proteins.TURKEY,
      badge: turkeyIcon,
      label: t('recipes:overview.six-recipes.recipe-4'),
      icon: 'turkey',
      link: '/recipes/turkey'
    },
    {
      name: Proteins.VENISON,
      badge: deerIcon,
      label: t('recipes:overview.six-recipes.recipe-5'),
      icon: 'deer',
      link: '/recipes/venison'
    },
    {
      name: Proteins.DUCK,
      badge: duckIcon,
      label: t('recipes:overview.six-recipes.recipe-6'),
      icon: 'duck',
      link: '/recipes/duck'
    },
  ]

  return (
    <>
      <BorderWrapper>
        <BorderWave
          background="accent-white"
          svgHeight="78px"
          invert
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
        <WfrWrapper>
          <Image src={wfr} alt="" />
        </WfrWrapper>
      </BorderWrapper>
      <ExploreRoot>
        <RecipesWrapper>
          <TitleWrapper>
            <SectionTitle>{t('recipes:individual.explore')}</SectionTitle>
          </TitleWrapper>
          <RecipesContainer>
            {RecipeList.map((recipe) => {
              if (recipe.name !== hide) {
                return (
                  <Stack
                    key={recipe.name}
                    direction="column"
                    alignItems="center"
                    gap={{ '@initial': '2', '@bp2': '4' }}
                  >
                    <Link href={recipe.link}>
                      <RecipeBadge>
                        <Image src={recipe.badge} alt={recipe.label} />
                      </RecipeBadge>
                    </Link>
                    <RecipePill large icon={recipe.icon} recipe={recipe.name}>
                      {recipe.label}
                    </RecipePill>
                  </Stack>
                )
              }
              return null
            })}
          </RecipesContainer>
        </RecipesWrapper>
      </ExploreRoot>
    </>
  )
}

Explore.displayName = 'Explore'
